import { DATA_TABLE_WATCH_PROPS } from '@/constants/data-table';

export default {
  methods: {
    handleOptionsChange (current, prev, callback) {
      const watchProps = DATA_TABLE_WATCH_PROPS;

      for (let i = 0; i < watchProps.length; i++) {
        const key = watchProps[i];

        if (prev[key] !== current[key]) {
          return callback();
        }
      }
    },
  },
};
